import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable()
export class DomainBlockInterceptor implements HttpInterceptor {
    constructor(private _api: ApiService) {}

    intercept(
        req: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        if (this._api.isDomainBlocked() && !this._api.isAllowedWhenDomainBlocked(req.url)) {
            return EMPTY;
        }

        return next.handle(req);
    }
}
